import React, { useState, useEffect } from "react";
import "./SubSubcategoriesTab.scss";
import { useDispatch, useSelector } from "react-redux";
import {
  createSubSubcategory,
  updateSubSubcategory,
  deleteSubSubcategory,
} from "../../../redux/actions/subsubcategory";
import { useToast } from "../../Layout/Toast/ToastProvider";
import {Loader} from '../../Layout/Loader';

const SubSubcategoriesTab = () => {
  const dispatch = useDispatch();
  const { showToast } = useToast();

  const { subcategories = [], isLoading: loadingSubcategories } = useSelector(
    (state) => state.subcategories || {}
  );
  const {
    subsubcategories = [],
    isLoading: loadingSubSubcategories,
    error,
  } = useSelector((state) => state.subsubcategories || {});

  const [subSubcategoryName, setSubSubcategoryName] = useState("");
  const [selectedParents, setSelectedParents] = useState([]);
  const [editingSubSubcategoryId, setEditingSubSubcategoryId] = useState(null);
  const [newSubSubcategoryName, setNewSubSubcategoryName] = useState("");
  const [newSelectedParents, setNewSelectedParents] = useState([]);

  useEffect(() => {
    if (error) {
      showToast(error, "error");
    }
  }, [error, showToast]);

  const handleCreateSubSubcategory = (e) => {
    e.preventDefault();
    if (!subSubcategoryName.trim()) {
      showToast("Заповніть ім'я суб-суб категорії!", "error");
      return;
    }
    if (selectedParents.length === 0) {
      showToast("Хочаби одна батьківська категорія обов'язкова!", "error");
      return;
    }
    dispatch(
      createSubSubcategory({
        name: subSubcategoryName,
        parentSubcategories: selectedParents,
      })
    ).then(() => {
      showToast("Суб-суб категорію успішно створено!", "success");
      setSubSubcategoryName("");
      setSelectedParents([]);
    });
  };

  const startEditing = (id, name, parentSubcategories) => {
    setEditingSubSubcategoryId(id);
    setNewSubSubcategoryName(name);
  
    const ids = parentSubcategories.map(pc => pc._id || pc);
    setNewSelectedParents(ids);
  };
  

  const handleUpdateSubSubcategory = (e) => {
    e.preventDefault();
    if (!newSubSubcategoryName.trim()) {
      showToast("Ім'я суб-суб категорії не може бути пусте!", "error");
      return;
    }
    if (newSelectedParents.length === 0) {
      showToast("Повинна існувати мінімум одна батьківська категорія", "error");
      return;
    }
    dispatch(
      updateSubSubcategory(editingSubSubcategoryId, {
        name: newSubSubcategoryName,
        parentSubcategories: newSelectedParents,
      })
    ).then(() => {
      showToast("Суб-суб категорію успішно оновлено!", "success");
      setEditingSubSubcategoryId(null);
      setNewSubSubcategoryName("");
      setNewSelectedParents([]);
    });
  };

  const handleDeleteSubSubcategory = (id) => {
    if (window.confirm("Ви впевнені що хочете видалити цю суб-субкатегорію?")) {
      dispatch(deleteSubSubcategory(id)).then(() =>
        showToast("Суб-суб категорію успішно видалено!", "success")
      );
    }
  };

  const handleParentSelection = (e, isEditing = false) => {
    const value = e.target.value;
    const setParents = isEditing ? setNewSelectedParents : setSelectedParents;
    const parents = isEditing ? newSelectedParents : selectedParents;

    if (e.target.checked) {
      setParents([...parents, value]);
    } else {
      setParents(parents.filter((parent) => parent !== value));
    }
  };

  return (
    <div className="sub-subcategories-tab">
      <h2 className="sub-subcategories-tab__heading">Керування Суб-суб категоріями</h2>

      <form
        onSubmit={handleCreateSubSubcategory}
        className="sub-subcategories-tab__form"
      >
        <input
          type="text"
          value={subSubcategoryName}
          onChange={(e) => setSubSubcategoryName(e.target.value)}
          placeholder="Введіть ім'я Суб-суб категорії"
          className="sub-subcategories-tab__form__input"
        />

        <div className="sub-subcategories-tab__form__parent-selection">
          <p className="font-semibold">Виберіть батьківські Суб-категорії:</p>
          <div className="sub-subcategories-tab__form__parent-selection__grrg">
          {subcategories.map((subcategory) => (
            <label
              key={subcategory._id}
              className="sub-subcategories-tab__form__parent-label"
            >
              <input
                type="checkbox"
                value={subcategory._id}
                onChange={(e) => handleParentSelection(e)}
                checked={selectedParents.includes(subcategory._id)}
                className="sub-subcategories-tab__form__parent-selection__checkbox"
              />
              {subcategory.name}
            </label>
          ))}
          </div>
        </div>

        <button
          type="submit"
          className="sub-subcategories-tab__form__submit-button"
          disabled={loadingSubcategories || loadingSubSubcategories}
        >
          {loadingSubcategories || loadingSubSubcategories
            ? "Додавання..."
            : "Додати Суб-суб категорію"}
        </button>
      </form>

      {loadingSubSubcategories ? (
        <Loader/>
      ) : subsubcategories.length > 0 ? (
        <ul className="sub-subcategories-tab__list">
          {subsubcategories.map((subsubcategory) => (
            <li
              key={subsubcategory._id}
              className="sub-subcategories-tab__list__item"
            >
              {editingSubSubcategoryId === subsubcategory._id ? (
                <form
                  onSubmit={handleUpdateSubSubcategory}
                  className="sub-subcategories-tab__list__item__edit-form"
                >
                  <input
                    type="text"
                    value={newSubSubcategoryName}
                    onChange={(e) => setNewSubSubcategoryName(e.target.value)}
                    className="sub-subcategories-tab__list__item__edit-form__edit-input"
                    placeholder="Sub-Subcategory name"
                  />
                  <div className="sub-subcategories-tab__list__item__edit-parents">
                    <p className="font-semibold">Виберіть батьківські Суб-категорії:</p>
                    <div className="sub-subcategories-tab__form__parent-selection__grrg">
                    {subcategories.map((subcategory) => (
                      <label key={subcategory._id} className="block">
                        <input
                          type="checkbox"
                          value={subcategory._id}
                          onChange={(e) => handleParentSelection(e, true)}
                          checked={newSelectedParents.includes(
                            subcategory._id
                          )}
                          className="sub-subcategories-tab__form__parent-selection__checkbox"
                        />
                        {subcategory.name}
                      </label>
                    ))}
                    </div>
                  </div>
                  <div className="sub-subcategories-tab__list__item__edit-form__edit-buttons">
                    <button
                      type="submit"
                      className="sub-subcategories-tab__button sub-subcategories-tab__button--save"
                    >
                      Зберегти
                    </button>
                    <button
                      type="button"
                      onClick={() => setEditingSubSubcategoryId(null)}
                      className="sub-subcategories-tab__button sub-subcategories-tab__button--cancel"
                    >
                      Скасувати
                    </button>
                  </div>
                </form>
              ) : (
                <div className="flex items-center justify-between">
                  <div>
                    <p className="font-semibold">{subsubcategory.name}</p>
                    <p className="text-sm">
                      Батьківські Суб-категорії:{" "}
                      {subsubcategory.parentSubcategories
                        .map((parent) => {
                          const parentId = parent._id;
                          return subcategories.find(
                            (subcategory) => subcategory._id === parentId
                          )?.name;
                        })
                        .filter(Boolean)
                        .join(", ") || "None"}
                    </p>
                  </div>
                  <div className="flex gap-2">
                    <button
                      onClick={() =>
                        startEditing(
                          subsubcategory._id,
                          subsubcategory.name,
                          subsubcategory.parentSubcategories
                        )
                      }
                      className="sub-subcategories-tab__button sub-subcategories-tab__button--edit"
                    >
                      Редагувати
                    </button>
                    <button
                      onClick={() =>
                        handleDeleteSubSubcategory(subsubcategory._id)
                      }
                      className="sub-subcategories-tab__button sub-subcategories-tab__button--delete"
                    >
                      Видалити
                    </button>
                  </div>
                </div>
              )}
            </li>
          ))}
        </ul>
      ) : (
        <p>Немає суб-суб категорій! Створіть нову щоб почати :)</p>
      )}
    </div>
  );
};

export default SubSubcategoriesTab;
